var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHearst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 106,
    viewBox: "0 0 258 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.25 11.5509H12.0359V93.6957H247.25V11.5509Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.036 2H2.19522V104H256.036V2Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.513 39.6705C188.229 36.7727 208.513 48.3636 208.513 48.3636C208.513 48.3636 207.934 50.6818 206.195 53C203.297 56.4773 195.184 57.6364 194.025 61.1136C192.795 64.8018 202.138 65.4717 199.241 68.5086C196.343 71.5455 184.172 72.7045 175.479 72.125C171.431 71.8551 172.582 76.1818 163.309 80.8182C160.991 79.6591 161.57 73.8636 157.513 73.2841C143.604 73.2841 138.604 71.0642 127.841 68.5086C125.105 67.8612 123.32 67.4886 120.423 68.0681C117.013 68.7501 111.623 70.9659 108.832 70.3863C106.04 69.8068 106.46 65.8283 103.036 63.4318C99.6124 61.0352 80.3955 54.9574 76.3771 57.6364C67.6839 63.4318 58.9907 61.1136 58.9907 61.1136C61.7583 57.9248 63.0291 56.1955 63.0475 53.5795C55.5134 51.2614 50.877 41.4091 49.7179 29.8181C49.7179 29.8181 62.468 47.2045 76.3771 48.3636C90.2861 49.5227 102.537 49.6059 109.991 48.3636C120.423 46.625 134.911 42.5682 134.911 42.5682C137.229 37.9318 133.752 32.1364 128.536 26.3409C143.025 26.9205 151.718 33.875 157.513 39.6705Z",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M246.763 11.2727H169.104V94.7273H246.763V11.2727Z",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.104 11.2727H90.2861V94.7273H169.104V11.2727Z",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2861 11.2727H11.4679V94.7273H90.2861V11.2727Z",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearst);
export default __webpack_public_path__ + "static/media/Hearst.ae3fdecd.svg";
export { ForwardRef as ReactComponent };var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHearst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 106,
    viewBox: "0 0 258 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.25 11.5509H12.0359V93.6957H247.25V11.5509Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.036 2H2.19522V104H256.036V2Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.513 39.6705C188.229 36.7727 208.513 48.3636 208.513 48.3636C208.513 48.3636 207.934 50.6818 206.195 53C203.297 56.4773 195.184 57.6364 194.025 61.1136C192.795 64.8018 202.138 65.4717 199.241 68.5086C196.343 71.5455 184.172 72.7045 175.479 72.125C171.431 71.8551 172.582 76.1818 163.309 80.8182C160.991 79.6591 161.57 73.8636 157.513 73.2841C143.604 73.2841 138.604 71.0642 127.841 68.5086C125.105 67.8612 123.32 67.4886 120.423 68.0681C117.013 68.7501 111.623 70.9659 108.832 70.3863C106.04 69.8068 106.46 65.8283 103.036 63.4318C99.6124 61.0352 80.3955 54.9574 76.3771 57.6364C67.6839 63.4318 58.9907 61.1136 58.9907 61.1136C61.7583 57.9248 63.0291 56.1955 63.0475 53.5795C55.5134 51.2614 50.877 41.4091 49.7179 29.8181C49.7179 29.8181 62.468 47.2045 76.3771 48.3636C90.2861 49.5227 102.537 49.6059 109.991 48.3636C120.423 46.625 134.911 42.5682 134.911 42.5682C137.229 37.9318 133.752 32.1364 128.536 26.3409C143.025 26.9205 151.718 33.875 157.513 39.6705Z",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M246.763 11.2727H169.104V94.7273H246.763V11.2727Z",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.104 11.2727H90.2861V94.7273H169.104V11.2727Z",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2861 11.2727H11.4679V94.7273H90.2861V11.2727Z",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearst);
export default __webpack_public_path__ + "static/media/Hearst.ae3fdecd.svg";
export { ForwardRef as ReactComponent };